import { antiFraudConstants } from '../constants'

const initialState = {
	sessionID: null
}

export default function antiFraudReducer(
	state = initialState,
	{ type, payload, errors }
) {
	switch (type) {
		case antiFraudConstants.GENERATE_SESSION_ID:
			return {
				sessionID: payload
			}

		default:
			return state
	}
}
